var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide_table),expression:"hide_table"}],staticClass:"hidden-tabs-message noselect"},[_c('span',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }